import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-728d25c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section rooms" }
const _hoisted_2 = ["onClick"]

import { ref, onMounted, inject, computed } from 'vue';
import { useStore } from 'vuex';
import { Report, Room, CustomerDictionary } from "@/models";
import ReportItemModal from "@/components/modals/ReportItemModal.vue";
import ReportRoomModal from "@/components/modals/ReportRoomModal.vue";
import ReportRoom from "@/components/report/Room.vue";
import { ReportsState } from '@/store/reports/types';
import { useEvent } from '@/eventBus';

// Inject actProperty

export default /*#__PURE__*/_defineComponent({
  __name: 'Rooms',
  setup(__props) {

const actProperty: any = inject('actProperty');

// Using Composition API
const store = useStore();
const reportsState = computed((): ReportsState => store.state.reports);
const focused = ref(-1);
const roomsShowBody = ref<boolean[]>([]);
const dynamicRefs = ref(null);

const report = computed((): Report => reportsState.value.current);

const getCustomersDictionaryAction = async (payload?: {
  companyname?: string;
  branchname?: string;
  reporttype?: string;
}): Promise<CustomerDictionary> => {
  return store.dispatch('customerdictionary/getCustomerDictionary', payload);
};

onMounted(() => {
  report.value.rooms.forEach((v, index) => {
    roomsShowBody.value[index] = true;
  });
  if (
    report.value &&
    actProperty.isFactoryreport(report.value.type) &&
    report.value.companyName
  ) {
    let cname = report.value.companyName;
    if (report.value.branchName && report.value.branchName != "default")
      cname = report.value.branchName;
    getCustomerDictionary(cname, "default", report.value.type);
  }
});

const getCustomerDictionary = async (
  companyname: any,
  branchname: any,
  reporttype: any
) => {
  if (companyname && companyname === "ACT") companyname = "default";
    getCustomersDictionaryAction({
      companyname,
      branchname,
      reporttype,
    }).catch((err: any) => {
      actProperty.displayError(err);
    });
};

const setActiveCard = (index: any) => {
  focused.value = index;
};

const syncRoomsShowBody = (index: number, showBody: boolean) => {
  const cardsrefArray = (dynamicRefs.value as any[]);
  if (cardsrefArray.length !== roomsShowBody.value.length) {
    // To cope with adding/removing rooms
    // or sometimes mounted won't set up this.roomsShowBody correctly
    const rooms: boolean[] = [];
    for (let i = 0; i < cardsrefArray.length; i++) {
      if (roomsShowBody.value[i] === undefined) {
        rooms[i] = true;
      } else if (i === index) {
        rooms[i] = showBody;
      } else {
        rooms[i] = roomsShowBody.value[i];
      }
    }
    roomsShowBody.value = rooms;
  } else {
    roomsShowBody.value = roomsShowBody.value.map((value, i) => {
      return i === index ? showBody : value;
    });
  }
};

/**
 * Expand all rooms
 */
 const expandAll = (): void => {
  const roomsOpened: boolean[] = [];
  if (dynamicRefs.value) {
    (dynamicRefs.value as any[]).forEach((card, index) => {
      card.showBody = true;
      roomsOpened[index] = true;
    });
  }

  roomsShowBody.value = roomsOpened;
}

/**
 * Collapse all rooms
 */
const collapseAll = (): void => {
  const roomsClosed: boolean[] = [];
  if (dynamicRefs.value) {
    (dynamicRefs.value as any[]).forEach((card, index) => {
      card.showBody = false;
      roomsClosed[index] = false;
    });
  }
  roomsShowBody.value = roomsClosed;
}

useEvent("expandAll", () => {
  expandAll()
});
useEvent("collapseAll", () => {
  collapseAll()
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.value.rooms, (room, $index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card",
        key: room._uuid,
        onClick: _withModifiers(($event: any) => (setActiveCard($index)), ["stop"])
      }, [
        _createVNode(ReportRoom, {
          room: room,
          index: $index,
          opened: 
          roomsShowBody.value[$index] === undefined ? true : roomsShowBody.value[$index]
        ,
          toggle: true,
          class: _normalizeClass({ activeCard: focused.value === $index }),
          ref_for: true,
          ref_key: "dynamicRefs",
          ref: dynamicRefs,
          onShowBody: syncRoomsShowBody
        }, null, 8, ["room", "index", "opened", "class"])
      ], 8, _hoisted_2))
    }), 128)),
    _createVNode(ReportItemModal),
    _createVNode(ReportRoomModal)
  ]))
}
}

})